<template>
    <div v-if="object" class="cart--body">
        <div class="cart-list">
            <CartProduct v-for="cartProduct in object.cart.cart_products" :key="cartProduct.id" :cartProduct="cartProduct" :product="cartProduct.product" @updateProductQuantity="updateProductQuantity( $event )" @removeProductFromCart="removeProductFromCart( $event )" />

            <div class="cart-list--tags">
                <div v-if="object.cart.free_delivery" class="cart-list--tags--item delivery-item">
                    Doprava ZDARMA
                </div>

                <div class="cart-list--tags--item calendar-item">
                    U vás do 2 pracovných dní
                </div>
            </div>
        </div>
    </div>

    <div v-if="object" class="cart--footer">
        <div class="cart--footer--col">
            <span class="btn btn-default btn-padding-medium" @click="backToShopping()">Späť k nákupu</span>
        </div>

        <div class="cart--footer--col">
            <div class="cart--footer--col--item">
                <small>Suma celkom:</small> <strong>{{ object.cart.products_price_with_tax_formatted }} <span>€</span></strong>
            </div>

            <div class="cart--footer--col--item">
                <a :href="object.cart.delivery_url" class="btn btn-action-red btn-padding-giant" @click.prevent="handleCheckout">Objednať</a>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import CartProduct from './CartProduct'

    export default {
        components: {
            CartProduct
        },
        props: {
            logged_user_id: {
                type: Number
            }
        },
        data() {
            return {
                object: null,
                viewCartEventRegistered: false
            }
        },
        created() {
            this.loadCart()
        },
        methods: {
            loadCart() {
                axios.post('/api/shop/cart/overview', { user_id: this.logged_user_id })
                .then(response => {
                    this.object = null

                    this.$nextTick(() => {
                        this.object = response.data.object
                        this.updateCartBadge()
                        if (!this.viewCartEventRegistered) {
                            typeof AnalyticScripts != "undefined" && AnalyticScripts.viewCartDataLayer(this.object.cart)
                            this.viewCartEventRegistered = true
                        }

                    })
                })
                .catch(errors => { console.log(errors.response.data.errors) })
            },
            updateCartBadge() {
                if (this.object && this.object.cart) {
                    const totalQuantity = this.object.cart.cart_products.reduce((sum, product) => {
                        return sum + product.product_quantity
                    }, 0)

                    document.querySelector('.cart-icon--badge').innerText = totalQuantity
                }
            },
            removeProductFromCart(product_id) {
                axios.delete(`/api/shop/cart/${this.object.cart.id}/product/${product_id}`)
                .then(response => {
                    if (response.data.status) return location.reload()
                    alert(response.data.message)
                })
                .catch(errors => { console.log(errors.response.data.errors) })
            },
            updateProductQuantity(data) {
                axios.put(`/api/shop/cart/${this.object.cart.id}/${data}`)
                .then(response => {
                    this.loadCart()
                })
                .catch(errors => { console.log(errors.response.data.errors) })
            },
            handleCheckout() {
                (typeof AnalyticScripts != "undefined") && AnalyticScripts.beginCheckoutDataLayer(this.object.cart);
                axios.post(`/api/shop/cart/${this.object.cart.id}/check-cart`)
                .then(response => {
                    if (response.data.status) {
                        window.location.href = this.object.cart.delivery_url;
                    } else {
                        alert(response.data.message)
                    }
                })
            }
        },
    }
</script>
